// App.js
import { BrowserRouter, Routes } from 'react-router-dom';
import GuestRoutes from './GuestRoutes';
import 'bootstrap/dist/css/bootstrap.css';
import { Toaster } from 'react-hot-toast';
import { useState } from 'react';
import { Provider } from 'react-redux';
import { store, persistor } from '../src/redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import "./App.css"

function App() {

  return (
    <>

      {process.env.REACT_APP_REMOTE_ORIGIN !== "https://eapi.equitypandit.in" && (
        <div>
          <div
            style={{
              position: "fixed", // Changed from "absolute" to "fixed"
              top: "70px",
              left: "-20px",
              backgroundColor: "#d32f2f",
              color: "white",
              padding: "5px 70px",
              fontWeight: "bold",
              fontSize: "14px",
              transform: "rotate(-30deg)",
              transformOrigin: "top left",
              boxShadow: "2px 2px 5px rgba(0,0,0,0.2)",
              zIndex: 3000,
            }}
          >
            Staging
          </div>
        </div>
      )}

      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Toaster position="top-center" reverseOrder={false} />
          <BrowserRouter>
            <GuestRoutes />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </>
  );
}

export default App;
